module.exports = __webpack_public_path__ + "img/pinpailinian@2x.d5e53a11.png";